import styled from 'styled-components';

import { getTypographyFontColor } from './helpers';

const Subtitle02 = styled.p`
    font-family: ${ ({ theme }) => theme.type.regularFont };
    font-weight: ${ ({ theme }) => theme.fontWeightMedium };
    color: ${ getTypographyFontColor };
    font-size: 14px;
    letter-spacing: 0.1px;
    line-height: 20px;
`;

export default Subtitle02;
